export const LocalesCodes = {
    EN: 'en',
    ES: 'es',
}

export const LocalesLabels = {
    [LocalesCodes.EN]: 'English',
    [LocalesCodes.ES]: 'Spanish',
}